import { render, staticRenderFns } from "./footer.block.pug?vue&type=template&id=810f624e&scoped=true&lang=pug&external"
import script from "./footer.block.ts?vue&type=script&lang=ts&external"
export * from "./footer.block.ts?vue&type=script&lang=ts&external"
import style0 from "./footer.block.sass?vue&type=style&index=0&id=810f624e&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810f624e",
  null
  
)

export default component.exports